import { render, staticRenderFns } from "./NavBasic.vue?vue&type=template&id=20745a2a"
import script from "./NavBasic.vue?vue&type=script&lang=js"
export * from "./NavBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports